<template>
    <div class="template-card" @click="onClick" :class="{ selected }">
        <div class="first">
            <span class="slug">{{ template.elementName }}</span>
            <div class="actions">
                <IconButton>
                    <a-icon type="edit" />
                </IconButton>
                <IconButton>
                    <a-icon type="eye" />
                </IconButton>
                <IconButton>TEST</IconButton>
            </div>
        </div>
        <div class="second">
            <div class="headers">
                <span>{{ $t("whatsapp_business_api.templateInfo") }}</span>
                <span>{{ $t("wp.description") }}</span>
                <span>{{ $t("message.status") }}</span>
                <span></span>
            </div>
            <div class="cells">
                <div class="cell cell1">
                    <div class="info-item">
                        <label>{{ $t("whatsapp_business_api.category") }} :</label> <span>{{ template.category }}</span>
                    </div>
                    <div class="info-item">
                        <label>{{ $t("settings.language") }} :</label> <span>{{ template.languageCode }}</span>
                    </div>
                    <div class="info-item">
                        <label>{{ $t("message.type") }} :</label> <span>{{ template.templateType }}</span>
                    </div>
                    <div class="info-item">
                        <label>ID:</label> <span>{{ template.id }}</span>
                    </div>
                </div>
                <div class="cell cell2">
                    <span>
                        {{ template.data }}
                    </span>
                </div>
                <div class="cell cell3">
                    <span v-if="template.status === 'REJECTED'"
                        >🔴 {{ $t("whatsapp_business_api.rejectWhatsapp") }}
                        <span class="d-block">
                            {{ template.reason }}
                        </span>
                    </span>
                    <span v-else-if="template.status === 'PENDING'"
                        >🟡 {{ $t("whatsapp_business_api.pendingWhatsapp") }}
                    </span>
                    <span v-else>🟢 {{ $t("whatsapp_business_api.approvedWhatsapp") }}</span>
                </div>
                <div class="cell cell4"></div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../Settings/components/IconButton.vue";

export default Vue.extend({
    name: "TemplateCard",
    components: { IconButton },
    props: {
        /**
         * {
         *         "appId": "ebf73c4f-1f45-4618-bb26-602b3cef9747",
         *         "category": "MARKETING",
         *         "containerMeta": "{\"appId\":\"ebf73c4f-1f45-4618-bb26-602b3cef9747\",\"data\":\"Ürünümüz hakkında bilgi almak istermisiniz ?\",\"header\":\"\",\"footer\":\"Footer\",\"sampleText\":\"Ürünümüz hakkında bilgi almak istermisiniz ?\",\"sampleHeader\":\"Example Header\",\"enableSample\":true,\"editTemplate\":false,\"allowTemplateCategoryChange\":false,\"addSecurityRecommendation\":false}",
         *         "createdOn": 1695505312406,
         *         "data": "Ürünümüz hakkında bilgi almak istermisiniz ?\nFooter",
         *         "elementName": "dynamic_template_egeumut_1",
         *         "id": "9c38e9bf-cb1b-475e-90be-782d94e6ce8d",
         *         "languageCode": "tr",
         *         "languagePolicy": "deterministic",
         *         "meta": "{\"example\":\"Ürünümüz hakkında bilgi almak istermisiniz ?\"}",
         *         "modifiedOn": 1695505312406,
         *         "namespace": "99810d7d_f652_4ee5_b316_624f5b283a4e",
         *         "priority": 1,
         *         "retry": 0,
         *         "stage": "NONE",
         *         "status": "PENDING",
         *         "templateType": "TEXT",
         *         "vertical": "bilgi mesajı",
         *         "wabaId": "102145199630713"
         *     }
         */
        template: {
            required: true,
        },
        onClick: {
            type: Function,
            default: () => {},
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
});
</script>

<style scoped lang="scss">
.template-card {
    display: flex;
    flex-direction: column;
    gap: 5px;
    border: 1px solid var(--color-border-default);
    padding: 10px;
    max-width: 1000px;
    cursor: pointer;
    border-left: 5px solid transparent;

    &.selected {
        border-left: 5px solid var(--color-border-info-default);
        background: #eeeeee;
    }

    .first {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .slug {
            font-size: 18px;
            font-weight: 700;
            text-decoration: underline;
            color: var(--color-text-info-default);
        }

        .actions {
            display: flex;
            gap: 5px;
        }
    }

    .second {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .headers {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid var(--color-border-default);

            span {
                font-weight: 700;
            }

            span:nth-child(1) {
                flex: 1 1 30%;
            }

            span:nth-child(2) {
                flex: 1 1 50%;
            }

            span:nth-child(3) {
                flex: 1 1 20%;
            }

            span:nth-child(4) {
                flex: 1 1 0%;
            }
        }

        .cells {
            display: flex;
            justify-content: space-between;

            .cell1 {
                display: flex;
                flex-direction: column;
                gap: 5px;
                flex: 1 1 30%;

                label {
                    font-weight: 700;
                }
            }

            .cell2 {
                text-align: left;
                flex: 1 1 50%;
            }

            .cell3 {
                flex: 1 1 20%;
            }

            .cell4 {
                flex: 1 1 0%;
            }
        }
    }
}
</style>
